import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, toDisplayString as _toDisplayString, unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "section" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "service-grid" }
const _hoisted_4 = { class: "service-top" }
const _hoisted_5 = { class: "service-icon" }
const _hoisted_6 = { class: "service-number" }
const _hoisted_7 = { class: "subpage-cta" }
const _hoisted_8 = { class: "container" }

import {ArrowRight, Baby, Bone, HeartPulse, ShieldCheck, Sparkles, Stethoscope} from 'lucide-vue-next';


export default /*@__PURE__*/_defineComponent({
  __name: 'ServiceView',
  setup(__props) {

const services = [{
  icon: ShieldCheck,
  title: 'Prophylaxe',
  text: 'Vorsorge, professionelle Zahnreinigung und individuelle Beratung für dauerhaft gesunde Zähne.'
}, {
  icon: HeartPulse,
  title: 'Zahnerhaltung & Endodontie',
  text: 'Substanzschonende Verfahren zum langfristigen Erhalt Ihrer natürlichen Zähne.'
}, {
  icon: Baby,
  title: 'Kinderzahnheilkunde',
  text: 'Behutsame, spielerische Vorsorge für Vertrauen und einen entspannten Praxisbesuch.'
}, {
  icon: Bone,
  title: 'Zahnersatz & Implantologie',
  text: 'Passgenaue Kronen, Brücken und implantatgetragene Versorgungen für sicheren Kaukomfort.'
}, {
  icon: Sparkles,
  title: 'Ästhetische Zahnheilkunde',
  text: 'Zahnfarbene Restaurationen und sorgfältig abgestimmte Konzepte für natürliche Ästhetik.'
}, {
  icon: Stethoscope,
  title: 'Parodontologie & CMD',
  text: 'Systematische Behandlung des Zahnhalteapparates und funktioneller Beschwerden.'
}]
return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", null, [
    _cache[4] || (_cache[4] = _createElementVNode("section", { class: "page-hero" }, [
      _createElementVNode("div", { class: "container" }, [
        _createElementVNode("span", { class: "eyebrow" }, "Unser Behandlungsspektrum"),
        _createElementVNode("h1", null, [
          _createTextVNode("Moderne Zahnmedizin."),
          _createElementVNode("br"),
          _createElementVNode("em", null, "Individuell für Sie.")
        ]),
        _createElementVNode("p", null, "Von der Vorsorge bis zur komplexen Versorgung begleiten wir Sie kompetent und persönlich.")
      ])
    ], -1)),
    _createElementVNode("section", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(services, (s, i) => {
            return _createElementVNode("article", {
              key: s.title,
              class: "service-card"
            }, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("span", _hoisted_5, [
                  (_openBlock(), _createBlock(_resolveDynamicComponent(s.icon)))
                ]),
                _createElementVNode("span", _hoisted_6, "0" + _toDisplayString(i + 1), 1)
              ]),
              _createElementVNode("h3", null, _toDisplayString(s.title), 1),
              _createElementVNode("p", null, _toDisplayString(s.text), 1),
              _createVNode(_component_router_link, { to: "/kontakt" }, {
                default: _withCtx(() => [
                  _cache[0] || (_cache[0] = _createTextVNode("Termin anfragen ", -1)),
                  _createVNode(_unref(ArrowRight))
                ]),
                _: 1
              })
            ])
          }), 64))
        ])
      ])
    ]),
    _createElementVNode("section", _hoisted_7, [
      _createElementVNode("div", _hoisted_8, [
        _cache[2] || (_cache[2] = _createElementVNode("h2", null, "Welche Behandlung passt zu Ihnen?", -1)),
        _cache[3] || (_cache[3] = _createElementVNode("p", null, "Wir beraten Sie verständlich und ohne Zeitdruck.", -1)),
        _createVNode(_component_router_link, {
          to: "/kontakt",
          class: "button primary"
        }, {
          default: _withCtx(() => [
            _cache[1] || (_cache[1] = _createTextVNode("Kontakt aufnehmen ", -1)),
            _createVNode(_unref(ArrowRight))
          ]),
          _: 1
        })
      ])
    ])
  ]))
}
}

})